export default {
  slug: 'roles-permissions',
  title: 'Roles & permissions',
  description: 'Operator roles and access expectations.',
  section: 'reference',
  order: 2,
  tags: ['roles', 'rbac', 'security'],
  body: `# Roles & permissions

Access is **role-based**. Your administrator assigns roles in **[Settings](/settings)** (admin only for user management).

## Common roles

| Role | Typical access |
|------|----------------|
| **Admin** | User management, full platform |
| **Lead investigator** | Cases, intelligence, engagement |
| **Investigator** | Cases, intelligence, limited engagement |
| **Analyst** | Read-heavy, enrichment, indicators |
| **Reviewer** | Review and approve outputs |
| **Client viewer** | Read-only client-safe views |
| **Operator** | Legacy C2 operator modules |
| **Read only** | Browse without mutations |

Exact permissions are enforced server-side on each API route. UI hiding is not a security boundary — unauthorized API calls return **403**.

## Intelligence APIs

Search, extract, promote, links, and graph endpoints require **Investigator** level or above (\`IsInvestigatorOrAbove\`).

## Audit

Sensitive actions (search created, indicator promoted, case updated) write to the audit log. Review **[Audit Log](/audit)** for compliance exports.

## MFA

When enabled, TOTP is required at login. Store recovery codes per organizational policy.
`,
};
